import script from "./TressScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressScroll.vue?vue&type=script&setup=true&lang=ts"

import "./TressScroll.vue?vue&type=style&index=0&id=5b3a2f97&lang=scss"

const __exports__ = script;

export default __exports__